export default function Problem() {
  const problems = [
    {
      icon: 'ri-mail-line',
      title: 'Surcharge d\'emails',
      description: 'Des centaines de messages quotidiens qui noient l\'essentiel'
    },
    {
      icon: 'ri-calendar-line',
      title: 'Agenda saturé',
      description: 'Réunions qui s\'enchaînent sans temps pour la réflexion stratégique'
    },
    {
      icon: 'ri-notification-line',
      title: 'Relances oubliées',
      description: 'Opportunités manquées par manque de suivi systématique'
    },
    {
      icon: 'ri-repeat-line',
      title: 'Tâches répétitives',
      description: 'Temps précieux perdu sur des actions à faible valeur ajoutée'
    }
  ];

  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Les dirigeants n'ont pas un problème de vision,
            <br />
            <span className="bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
              mais de temps.
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Chaque jour, des heures sont perdues dans l'opérationnel au détriment de la stratégie.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-xl p-6 hover:border-violet-500/50 transition-all group cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-violet-600/20 to-blue-600/20 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                <i className={`${problem.icon} text-2xl text-violet-400`}></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">{problem.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{problem.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}